var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex justify-center align-stretch flex-wrap mx-n3"},[(_vm.itemsForSaleState.isLoading)?[_c('NftCardSkeletonLoader',{staticClass:"nft-card g-background-primary",attrs:{"col-layout-bp":'lg'}}),_vm._v(" "),_c('NftCardSkeletonLoader',{staticClass:"nft-card g-background-primary mt-16",attrs:{"col-layout-bp":'lg'}})]:_vm._l((_vm.itemsForSale),function(item,i){return _c('NftCard',{key:i,class:{
        'nft-card': true,
        'mt-16': !!i,
      },attrs:{"col-layout-bp":'lg',"item":item,"slug":item.filmNftSlug}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }